import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        FlexLayoutModule,
        MatExpansionModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatGridListModule,
        MatToolbarModule,
        MatButtonModule,
        MatRadioModule,
        MatChipsModule,
        MatCheckboxModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatInputModule,
        MatStepperModule,
        MatTabsModule,
        MatProgressBarModule,
        MatTableModule,
        MatSortModule
    ],
    declarations: [
    ],
    exports: [
        FlexLayoutModule,
        MatExpansionModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatGridListModule,
        MatToolbarModule,
        MatButtonModule,
        MatRadioModule,
        MatChipsModule,
        MatCheckboxModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatInputModule,
        MatStepperModule,
        MatTabsModule,
        MatProgressBarModule,
        MatTableModule,
        MatSortModule
    ],
    providers: [],

})
export class MaterialLayoutsModule { }
